import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../common.service';
import { PaginatedResponse } from '../../../types/common.model';
import { ReportEntityType } from '../enums/report.enum';
import {
  ProviderBillingReportSummary,
  ProviderCurrentPayRunSummary,
  ReportBatch,
  ReportBatchRequest,
  ReportResponse,
} from '../model/report.model';

@Injectable({ providedIn: 'root' })
export class ReportsService {
  private readonly api = inject(ApiService);

  getReportBatches(
    entityId: number,
    entityType: ReportEntityType,
    page: number,
    pageSize: number,
  ): Observable<PaginatedResponse<ReportBatch>> {
    return this.api.get<PaginatedResponse<ReportBatch>>(
      `reportbatch/app/Hub/entityType/${entityType}/entity/${entityId}`,
      { page, pageSize },
    );
  }

  getReportsByAppType(appType: string): Observable<ReportResponse[]> {
    return this.api.get<ReportResponse[]>(`report/appType/${appType}`);
  }

  getReportBatchBlob(reportBatchId: number, fileType: 'csv' | 'pdf' | 'aba'): Observable<Blob> {
    return this.api.getBlobReport(`reportbatch/${reportBatchId}/reportcsv`, undefined, fileType);
  }

  getCurrentPayrunDataByBatchId(
    tenantId: number,
    reportBatchId: number,
  ): Observable<ProviderCurrentPayRunSummary[]> {
    return this.api.get<ProviderCurrentPayRunSummary[]>(
      `tenant/${tenantId}/reportbatch/${reportBatchId}`,
    );
  }

  getCurrentBillingDataByBatchId(
    tenantId: number,
    reportBatchId: number,
  ): Observable<ProviderBillingReportSummary[]> {
    return this.api.get<ProviderBillingReportSummary[]>(
      `tenant/${tenantId}/reportbatch/billing/${reportBatchId}`,
    );
  }

  createReportBatch(request: ReportBatchRequest): Observable<void> {
    return this.api.post<ReportBatchRequest, void>('reportbatch', request);
  }

  getCustomReportList(tenantId: number): Observable<any[]> {
    return this.api.get<any[]>(`CustomReportList/${tenantId}`);
  }

  getCorporateLevelCustomReportList(corporateId: number): Observable<any[]> {
    return this.api.get<any[]>(`CustomReportList/corporate/${corporateId}`);
  }
}
